import { OrderStateEnum, OrderTypesEnum } from '@frontend-workspace/react-shared-lib';

export function getOrderStateLabel(
  order: { state: OrderStateEnum; orderType?: string },
  translate: (key: string) => string
): string {
  return order.state === OrderStateEnum.Pending && order.orderType === OrderTypesEnum.SFAddSupportHoursOrder
    ? translate('supportOrders.waitingForAgreement')
    : order.state;
}

export function getSalesforceFollowUpLabel(
  order: { state: OrderStateEnum; orderType?: string; errorMessage?: string | null },
  translate: (key: string) => string
): string {
  if (order.state === OrderStateEnum.Failed ||
      (order.state === OrderStateEnum.Open && order.errorMessage))
    return translate('supportOrders.executionFailed');
  if (order.state === OrderStateEnum.Open)
    return translate(order.orderType === OrderTypesEnum.SFChangeAssetOrder
      ? 'supportOrders.awaitingManualExecution' : 'supportOrders.awaitingExecution');
  return getOrderStateLabel(order, translate);
}
